// Generated by scripts/build-ui-icons.mjs.
export { ShareNetwork as default } from "../ui/glyphs-6";
